module.exports = __webpack_public_path__ + "static/android-chrome-512x512-0ed17f233967865906962049f3ff66ab.png";